"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _htmlbars = _interopRequireDefault(require("highlight.js/lib/languages/htmlbars"));

var _default = _htmlbars["default"];
exports["default"] = _default;